import Toast from "../ui/Toast/Toast";
import PageBackButton from "../ui/Page/PageBackButton";
import PageHero from "../ui/Page/PageHero";
import PageShell from "../ui/Page/PageShell";
import GuardianConnectionsPanel from "./GuardianConnectionsPanel";
import GuardianInviteComposer from "./GuardianInviteComposer";
import GuardianRequestsPanel from "./GuardianRequestsPanel";
import type { GuardianWorkspaceProps } from "./types";

const GuardianWorkspace = ({
  backButtonLabel,
  backButtonFallbackTo,
  heroEyebrow,
  heroTitle,
  heroDescription,
  stats,
  isLoading,
  pageError,
  toast,
  onDismissToast,
  composer,
  targetEmail,
  composerError,
  submitting,
  onTargetEmailChange,
  onSubmit,
  activeTitle,
  activeSubtitle,
  activeEmptyMessage,
  activeItems,
  incomingSection,
  outgoingSection,
  activeFooter,
  setupBanner,
}: GuardianWorkspaceProps) => {
  return (
    <PageShell width="7xl">
      <Toast
        isOpen={toast !== null}
        message={toast?.message ?? ""}
        tone={toast?.tone ?? "info"}
        onClose={onDismissToast}
      />
      {backButtonLabel && backButtonFallbackTo ? (
        <PageBackButton fallbackTo={backButtonFallbackTo} label={backButtonLabel} className="mb-4" />
      ) : null}

      <PageHero
        eyebrow={heroEyebrow}
        title={heroTitle}
        description={heroDescription}
        stats={stats}
      />

      {setupBanner ? <section className="mt-6">{setupBanner}</section> : null}

      {pageError ? <p className="mt-6 text-sm font-medium text-red-600">{pageError}</p> : null}
      {isLoading ? <p className="mt-6 text-myteengig-text-muted">Loading guardian workspace...</p> : null}

      {!isLoading ? (
        <>
          <section className="mt-8 grid gap-6 xl:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)]">
            <GuardianInviteComposer
              config={composer}
              targetEmail={targetEmail}
              submitting={submitting}
              error={composerError}
              onTargetEmailChange={onTargetEmailChange}
              onSubmit={onSubmit}
            />
            <GuardianConnectionsPanel
              title={activeTitle}
              subtitle={activeSubtitle}
              emptyMessage={activeEmptyMessage}
              items={activeItems}
              footer={activeFooter}
            />
          </section>

          <section className="mt-8 grid gap-6 xl:grid-cols-2">
            <GuardianRequestsPanel section={incomingSection} />
            <GuardianRequestsPanel section={outgoingSection} />
          </section>
        </>
      ) : null}
    </PageShell>
  );
};

export default GuardianWorkspace;
